// Translation file for all text content
export const translations = {
  ar: {
    // Navigation
    nav: {
      branches: 'الفروع',
      sections: 'الأقسام',
      contact: 'تواصل معنا',
      back: 'العودة',
      backToBranches: 'العودة للفروع',
      search: 'البحث',
      language: 'EN',
      brandName: 'بروز',
      dragTip: 'اسحب لليسار'
    },
    
    // Categories
    categories: {
      title: 'الفئات',
      filter: 'التصفية والترتيب',
      search: 'البحث',
      searchPlaceholder: 'ابحث عن فئة...',
      sortBy: 'الترتيب حسب',
      sortByName: 'الاسم (أ-ي)',
      sortByOriginal: 'الترتيب الأصلي',
      results: 'عدد النتائج',
      noResults: 'لا توجد نتائج',
      loading: 'جاري التحميل...',
      disclaimer: 'يحتاج البالغون من العمر إلى 2000 سعرة حرارية في المتوسط يومياً وقد تختلف الإحتياجات الفردية من السعرات الحرارية من شخص لشخص. جميع الأسعار شاملة ضريبة القيمة المضافة.'
    },
    
    // Products
    products: {
      title: 'المنتجات',
      filter: 'التصفية والترتيب',
      search: 'البحث (الاسم أو المكونات)',
      searchPlaceholder: 'ابحث عن منتج أو مكون...',
      descriptionSearch: 'البحث في الوصف',
      descriptionPlaceholder: 'ابحث في وصف المنتج...',
      priceRange: 'نطاق السعر',
      minPrice: 'الحد الأدنى',
      maxPrice: 'الحد الأقصى',
      sortByName: 'الاسم (أ-ي)',
      sortByPriceLow: 'السعر (من الأقل للأعلى)',
      sortByPriceHigh: 'السعر (من الأعلى للأقل)',
      sortByIngredients: 'عدد المكونات (الأكثر)',
      results: 'عدد النتائج',
      noProducts: 'لا توجد منتجات متاحة',
      showIngredients: 'عرض المكونات',
      hideIngredients: 'إخفاء المكونات',
      ingredients: 'المكونات',
      calories: 'السعرات الحرارية',
      calorieUnit: 'سعرة',
      currency: 'ر.س',
      loading: 'جاري التحميل...',
      moreDetails: 'المزيد من التفاصيل',
      from: 'من',
      selectSize: 'اختر الحجم',
      required: 'مطلوب  ',
      price: 'السعر',
      description: 'الوصف',
      notFound: 'المنتج غير موجود',
      noImage: 'لا توجد صورة متاحة',
      additions: 'الإضافات',
      chooseAdditions: 'يمكنك اختيار أكثر من إضافة',
      allergens: 'مسببات الحساسية',
      alerts: 'تنبيهات',
      nutritionalFacts: 'الحقائق التغذوية',
      bestSeller: 'الأكثر مبيعًا',
      noAllergensInfo: 'لا توجد تنبيهات مسببات حساسية لهذا المنتج.',
      disclaimer: 'يحتاج البالغون من العمر إلى 2000 سعرة حرارية في المتوسط يومياً وقد تختلف الإحتياجات الفردية من السعرات الحرارية من شخص لشخص. جميع الأسعار شاملة ضريبة القيمة المضافة.'
    },
    
    // Branches
    branches: {
      title: 'الفروع',
      filter: 'التصفية والترتيب',
      search: 'البحث',
      searchPlaceholder: 'ابحث عن فرع...',
      sortByName: 'الاسم (أ-ي)',
      sortByOriginal: 'الترتيب الأصلي',
      results: 'عدد النتائج',
      noBranches: 'لا توجد فروع',
      branchNotFound: 'الفرع غير موجود',
      backToBranches: 'العودة للفروع',
      noCategories: 'لا توجد فئات متاحة لهذا الفرع',
      loading: 'جاري التحميل...',
    },
    
    // Branch Selector
    branchSelector: {
      title: 'اختر فرعك',
      subtitle: 'يرجى اختيار الفرع الذي تريد تصفح منتجاته',
      searchPlaceholder: 'ابحث عن فرع...',
      skip: 'تخطي',
      noBranches: 'لا توجد فروع متاحة',
      // Branch names and locations
      branchNames: {
        1: 'فرع الرياض',
        2: 'فرع جدة',
        3: 'فرع الدمام',
        4: 'فرع الخبر',
        5: 'فرع الطائف',
        6: 'فرع أبها'
      },
      branchLocations: {
        1: 'الرياض، حي النخيل',
        2: 'جدة، حي الزهراء',
        3: 'الدمام، حي الفيصلية',
        4: 'الخبر، حي الكورنيش',
        5: 'الطائف، حي الشهداء',
        6: 'أبها، حي المطار'
      }
    },
    
    // Search
    search: {
      title: 'البحث',
      placeholder: 'ابحث عن منتج، فئة، أو فرع...',
      resultsFound: 'تم العثور على',
      result: 'نتيجة',
      results: 'نتائج',
      products: 'المنتجات',
      categories: 'الفئات',
      branches: 'الفروع',
      noResults: 'لم يتم العثور على نتائج',
      tryDifferent: 'جرب البحث بكلمات مختلفة',
      enterSearch: 'يرجى إدخال كلمة بحث',
      category: 'فئة',
      type: 'نوع',
      loading: 'جاري البحث...'
    },
    contact: {
      phone: 'رقم الهاتف',
      whatsapp: 'واتساب',
      email: 'البريد الإلكتروني',
      address: 'العنوان',
      website: 'الموقع الإلكتروني',
      noContactInfo: 'لا توجد بيانات تواصل متاحة حالياً.'
    },
    
    // Category names
    categoryNames: {
      baits: 'بايتس',
      boxes: 'بوكسات الجمعات',
      choosendrinks: 'مشروبات مختارة',
      crepes: 'كريبات',
      drinkboxes: 'بوكسات المشروبات',
      hotcoffees: 'قهوة ساخنة',
      matcha: 'ماتشا',
      minicakes: 'ميني كيك',
      mohito: 'موخيتو',
      morning: 'حلا الصباح',
      products: 'منتجاتنا',
      smoothies: 'سموزي',
      souchi: 'سوشي',
      waffel: 'وافل'
    },
    
    // Product names and descriptions
    productNames: {
      // Baits
      'baits.1.name': 'بايت 1',
      'baits.1.description': 'بايت لذيذ ومميز بطعم فريد',
      'baits.2.name': 'بايت 2',
      'baits.2.description': 'بايت شهي بجودة عالية',
      'baits.3.name': 'بايت 3',
      'baits.3.description': 'بايت مميز بطعم رائع',
      
      // Boxes
      'boxes.1.name': 'بوكس 1',
      'boxes.1.description': 'بوكس جماعي مثالي للجمعات',
      'boxes.2.name': 'بوكس 2',
      'boxes.2.description': 'بوكس مميز باختيارات متنوعة',
      'boxes.3.name': 'بوكس 3',
      'boxes.3.description': 'بوكس اقتصادي بجودة عالية',
      'boxes.4.name': 'بوكس 4',
      'boxes.4.description': 'بوكس فاخر باختيارات مميزة',
      'boxes.5.name': 'بوكس 5',
      'boxes.5.description': 'بوكس كبير بكمية وفيرة',
      'boxes.6.name': 'بوكس 6',
      'boxes.6.description': 'بوكس متوسط الحجم',
      
      // Choosendrinks
      'choosendrinks.1.name': 'مشروب مختار 1',
      'choosendrinks.1.description': 'مشروب منعش وطبيعي',
      'choosendrinks.2.name': 'مشروب مختار 2',
      'choosendrinks.2.description': 'مشروب مميز بطعم فريد',
      'choosendrinks.3.name': 'مشروب مختار 3',
      'choosendrinks.3.description': 'مشروب منعش وصحي',
      'choosendrinks.4.name': 'مشروب مختار 4',
      'choosendrinks.4.description': 'مشروب فاخر بجودة عالية',
      
      // Crepes
      'crepes.1.name': 'كريب 1',
      'crepes.1.description': 'كريب لذيذ وحلو',
      'crepes.2.name': 'كريب 2',
      'crepes.2.description': 'كريب مميز بطبقات متعددة',
      
      // Drinkboxes
      'drinkboxes.1.name': 'بوكس مشروب 1',
      'drinkboxes.1.description': 'بوكس مشروبات متنوعة',
      'drinkboxes.2.name': 'بوكس مشروب 2',
      'drinkboxes.2.description': 'بوكس مشروبات فاخرة',
      'drinkboxes.3.name': 'بوكس مشروب 3',
      'drinkboxes.3.description': 'بوكس مشروبات اقتصادي',
      'drinkboxes.4.name': 'بوكس مشروب 4',
      'drinkboxes.4.description': 'بوكس مشروبات متوسط',
      'drinkboxes.5.name': 'بوكس مشروب 5',
      'drinkboxes.5.description': 'بوكس مشروبات كبير',
      'drinkboxes.6.name': 'بوكس مشروب 6',
      'drinkboxes.6.description': 'بوكس مشروبات متنوع',
      
      // Hotcoffees
      'hotcoffees.1.name': 'قهوة ساخنة 1',
      'hotcoffees.1.description': 'قهوة عربية أصيلة',
      'hotcoffees.2.name': 'قهوة ساخنة 2',
      'hotcoffees.2.description': 'قهوة إيطالية فاخرة',
      'hotcoffees.3.name': 'قهوة ساخنة 3',
      'hotcoffees.3.description': 'قهوة تركية تقليدية',
      'hotcoffees.4.name': 'قهوة ساخنة 4',
      'hotcoffees.4.description': 'قهوة أمريكية قوية',
      'hotcoffees.5.name': 'قهوة ساخنة 5',
      'hotcoffees.5.description': 'قهوة إسبريسو إيطالية',
      'hotcoffees.6.name': 'قهوة ساخنة 6',
      'hotcoffees.6.description': 'قهوة لاتيه كريمي',
      
      // Matcha
      'matcha.1.name': 'ماتشا 1',
      'matcha.1.description': 'ماتشا ياباني أصيل',
      'matcha.2.name': 'ماتشا 2',
      'matcha.2.description': 'ماتشا فاخر بجودة عالية',
      'matcha.3.name': 'ماتشا 3',
      'matcha.3.description': 'ماتشا منعش وطبيعي',
      
      // Minicakes
      'minicakes.1.name': 'ميني كيك 1',
      'minicakes.1.description': 'كيك صغير لذيذ',
      'minicakes.2.name': 'ميني كيك 2',
      'minicakes.2.description': 'كيك صغير بطبقات متعددة',
      'minicakes.3.name': 'ميني كيك 3',
      'minicakes.3.description': 'كيك صغير بسيط',
      'minicakes.4.name': 'ميني كيك 4',
      'minicakes.4.description': 'كيك صغير مميز',
      'minicakes.5.name': 'ميني كيك 5',
      'minicakes.5.description': 'كيك صغير فاخر',
      'minicakes.6.name': 'ميني كيك 6',
      'minicakes.6.description': 'كيك صغير منعش',
      
      // Mohito
      'mohito.1.name': 'موخيتو 1',
      'mohito.1.description': 'موخيتو منعش وطبيعي',
      'mohito.2.name': 'موخيتو 2',
      'mohito.2.description': 'موخيتو فاخر بنكهة مميزة',
      'mohito.3.name': 'موخيتو 3',
      'mohito.3.description': 'موخيتو كلاسيكي',
      'mohito.4.name': 'موخيتو 4',
      'mohito.4.description': 'موخيتو مميز بطعم فريد',
      'mohito.5.name': 'موخيتو 5',
      'mohito.5.description': 'موخيتو فاخر بجودة عالية',
      'mohito.6.name': 'موخيتو 6',
      'mohito.6.description': 'موخيتو منعش وصحي',
      
      // Morning
      'morning.1.name': 'حلا الصباح 1',
      'morning.1.description': 'حلا صباحي لذيذ',
      'morning.2.name': 'حلا الصباح 2',
      'morning.2.description': 'حلا صباحي فاخر',
      'morning.3.name': 'حلا الصباح 3',
      'morning.3.description': 'حلا صباحي بسيط',
      
      // Products
      'products.1.name': 'منتج 1',
      'products.1.description': 'منتج مميز بجودة عالية',
      'products.2.name': 'منتج 2',
      'products.2.description': 'منتج فاخر بطعم رائع',
      'products.3.name': 'منتج 3',
      'products.3.description': 'منتج اقتصادي',
      'products.4.name': 'منتج 4',
      'products.4.description': 'منتج متوسط الجودة',
      
      // Smoothies
      'smoothies.1.name': 'سموزي 1',
      'smoothies.1.description': 'سموزي طبيعي وصحي',
      
      // Souchi
      'souchi.1.name': 'سوشي 1',
      'souchi.1.description': 'سوشي ياباني أصيل',
      'souchi.2.name': 'سوشي 2',
      'souchi.2.description': 'سوشي فاخر بجودة عالية',
      'souchi.3.name': 'سوشي 3',
      'souchi.3.description': 'سوشي تقليدي',
      
      // Waffel
      'waffel.1.name': 'وافل 1',
      'waffel.1.description': 'وافل لذيذ ومقرمش',
      'waffel.2.name': 'وافل 2',
      'waffel.2.description': 'وافل فاخر بطبقات متعددة',
      'waffel.3.name': 'وافل 3',
      'waffel.3.description': 'وافل بسيط',
      'waffel.4.name': 'وافل 4',
      'waffel.4.description': 'وافل مميز',
      'waffel.5.name': 'وافل 5',
      'waffel.5.description': 'وافل فاخر',
      'waffel.6.name': 'وافل 6',
      'waffel.6.description': 'وافل منعش'
    },
    
    // Dashboard
    dashboard: {
      title: 'لوحة التحكم',
      welcome: 'مرحباً',
      logout: 'تسجيل الخروج',
      overview: 'نظرة عامة',
      totalViews: 'إجمالي المشاهدات',
      todayViews: 'مشاهدات اليوم',
      weekViews: 'مشاهدات هذا الأسبوع',
      monthViews: 'مشاهدات هذا الشهر',
      categories: 'الفئات',
      products: 'المنتجات',
      branches: 'الفروع',
      heroImages: 'صور ',
      analytics: 'التحليلات',
      viewsByDevice: 'المشاهدات حسب الجهاز',
      dailyViews: 'المشاهدات اليومية',
      topPages: 'الصفحات الأكثر زيارة',
      mobile: 'جوال',
      desktop: 'سطح المكتب',
      tablet: 'تابلت',
      views: 'مشاهدات',
      page: 'صفحة',
      noData: 'لا توجد بيانات',
      manageCategories: 'إدارة الفئات',
      manageProducts: 'إدارة المنتجات',
      manageBranches: 'إدارة الفروع',
      viewAll: 'عرض الكل',
      period: 'الفترة',
      last7Days: 'آخر 7 أيام',
      last30Days: 'آخر 30 يوم',
      last90Days: 'آخر 90 يوم',
      allergensAdditions: 'مسببات الحساسية والإضافات',
      loading: 'جاري التحميل...'
    },
    
    // Admin Pages
    admin: {
      back: 'العودة',
      add: 'إضافة',
      edit: 'تعديل',
      delete: 'حذف',
      save: 'حفظ',
      cancel: 'إلغاء',
      loading: 'جاري التحميل...',
      categories: 'الفئات',
      products: 'المنتجات',
      branches: 'الفروع',
      addCategory: 'إضافة فئة',
      editCategory: 'تعديل فئة',
      addProduct: 'إضافة منتج',
      editProduct: 'تعديل منتج',
      addBranch: 'إضافة فرع',
      editBranch: 'تعديل فرع',
      deleteConfirm: 'هل أنت متأكد من حذف هذا العنصر؟',
      keyName: 'اسم المفتاح',
      nameAr: 'الاسم (عربي)',
      nameEn: 'الاسم (إنجليزي)',
      descriptionAr: 'الوصف (عربي)',
      descriptionEn: 'الوصف (إنجليزي)',
      image: 'الصورة',
      displayOrder: 'ترتيب العرض',
      active: 'نشط',
      category: 'الفئة',
      selectCategory: 'اختر الفئة',
      price: 'السعر',
      priceSAR: 'السعر (ر.س)',
      calories: 'السعرات الحرارية',
      caloriesPlaceholder: 'أدخل السعرات الحرارية',
      ingredients: 'المكونات',
      ingredientAr: 'المكون (عربي)',
      ingredientEn: 'المكون (إنجليزي)',
      addIngredient: 'إضافة مكون',
      remove: 'إزالة',
      logo: 'الشعار',
      logoHint: 'ارفع شعار الموقع (يفضل PNG/WebP بخلفية شفافة).',
      saveLogo: 'حفظ الشعار',
      currentLogo: 'الشعار الحالي',
      logoUpdated: 'تم تحديث الشعار بنجاح',
      noLogo: 'لا يوجد شعار محدد',
      preview: 'معاينة',
      saving: 'جاري الحفظ...',
      search: 'بحث',
      searchPlaceholder: 'ابحث بالاسم',
      allCategories: 'كل الفئات',
      status: 'الحالة',
      all: 'الكل',
      inactive: 'غير نشط',
      results: 'النتائج',
      noResults: 'لا توجد نتائج مطابقة',
      locationAr: 'الموقع (عربي)',
      locationEn: 'الموقع (إنجليزي)',
      phone: 'الهاتف',
      branchCategories: 'فئات الفرع',
      id: 'الرقم',
      key: 'المفتاح',
      order: 'الترتيب',
      actions: 'الإجراءات',
      yes: 'نعم',
      no: 'لا',
      required: 'مطلوب',
      error: 'حدث خطأ',
      manageSizes: 'إدارة الأحجام',
      sizesList: 'قائمة الأحجام',
      sizeNameAr: 'اسم الحجم (عربي)',
      sizeNameEn: 'اسم الحجم (إنجليزي)',
      noSizes: 'لا توجد أحجام مضافة بعد',
      clear: 'مسح',
      update: 'تحديث',
      close: 'إغلاق',
      heroImages: 'صور ',
      heroImage: 'صورة ',
      addHeroImage: 'إضافة صورة بطل',
      editHeroImage: 'تعديل صورة بطل',
      titleAr: 'العنوان (عربي)',
      titleEn: 'العنوان (إنجليزي)',
      link: 'الرابط',
      linkUrl: 'رابط URL',
      linkUrlHint: 'إذا تم توفيره، سيتم الانتقال إلى هذا الرابط عند النقر على الصورة',
      displayOrderHint: 'الأرقام الأقل تظهر أولاً في السلايدر',
      activeHint: 'فقط الصور النشطة ستظهر على الموقع',
      noHeroImages: 'لا توجد صور بطل. أضف صورتك الأولى!',
      allergensAdditions: 'مسببات الحساسية والإضافات',
      manageAllergens: 'إدارة مسببات الحساسية',
      manageFixedAdditions: 'إدارة الإضافات الثابتة',
      allergen: 'مسبب حساسية',
      addition: 'إضافة',
      icon: 'الأيقونة',
      errorLoadingData: 'خطأ في تحميل البيانات',
      errorSavingAllergen: 'خطأ في حفظ مسبب الحساسية',
      errorSavingAddition: 'خطأ في حفظ الإضافة',
      deleteAllergenConfirm: 'هل أنت متأكد من حذف مسبب الحساسية؟',
      deleteAdditionConfirm: 'هل أنت متأكد من حذف الإضافة؟',
      errorLoadingProductDetails: 'فشل تحميل تفاصيل المنتج',
      productAllergensLabel: 'مسببات الحساسية (اختر ما يحتويه المنتج)',
      allowedAdditionsLabel: 'الإضافات المسموح بها',
      discountPercent: 'خصم %',
      isBestseller: 'الأكثر مبيعًا'
      ,
      contactSettings: 'إعدادات التواصل',
      savedContact: 'تم حفظ بيانات التواصل'
    }
  },
  
  en: {
    // Navigation
    nav: {
      branches: 'Branches',
      sections: 'Sections',
      contact: 'Contact Us',
      back: 'Back',
      backToBranches: 'Back to Branches',
      search: 'Search',
      language: 'AR',
      brandName: 'Bros',
      dragTip: 'Drag to scroll'
    },
    
    // Categories
    categories: {
      title: 'Categories',
      filter: 'Filter & Sort',
      search: 'Search',
      searchPlaceholder: 'Search for a category...',
      sortBy: 'Sort By',
      sortByName: 'Name (A-Z)',
      sortByOriginal: 'Original Order',
      results: 'Results',
      noResults: 'No results found',
      loading: 'Loading...',
      disclaimer: 'Adults need an average of 2000 calories per day and individual calorie needs may vary from person to person. All prices include VAT.'
    },
    
    // Products
    products: {
      title: 'Products',
      filter: 'Filter & Sort',
      search: 'Search (Name or Ingredients)',
      searchPlaceholder: 'Search for a product or ingredient...',
      descriptionSearch: 'Search in Description',
      descriptionPlaceholder: 'Search in product description...',
      priceRange: 'Price Range',
      minPrice: 'Min Price',
      maxPrice: 'Max Price',
      sortByName: 'Name (A-Z)',
      sortByPriceLow: 'Price (Low to High)',
      sortByPriceHigh: 'Price (High to Low)',
      sortByIngredients: 'Ingredients Count (Most)',
      results: 'Results',
      noProducts: 'No products available',
      showIngredients: 'Show Ingredients',
      hideIngredients: 'Hide Ingredients',
      ingredients: 'Ingredients',
      calories: 'Calories',
      calorieUnit: 'Cal',
      currency: 'SAR',
      loading: 'Loading...',
      moreDetails: 'More Details',
      from: 'from',
      selectSize: 'Select Size',
      required: 'Required. Select 1 additional. 1',
      price: 'Price',
      description: 'Description',
      notFound: 'Product not found',
      noImage: 'No Image Available',
      additions: 'Additions',
      chooseAdditions: 'You can select more than one addition',
      allergens: 'Allergens',
      alerts: 'Alerts',
      nutritionalFacts: 'Nutritional facts',
      bestSeller: 'Best seller',
      noAllergensInfo: 'No allergen alerts for this product.',
      disclaimer: 'Adults need an average of 2000 calories per day and individual calorie needs may vary from person to person. All prices include VAT.'
    },
    
    // Branches
    branches: {
      title: 'Branches',
      filter: 'Filter & Sort',
      search: 'Search',
      searchPlaceholder: 'Search for a branch...',
      sortByName: 'Name (A-Z)',
      sortByOriginal: 'Original Order',
      results: 'Results',
      noBranches: 'No branches found',
      branchNotFound: 'Branch not found',
      backToBranches: 'Back to Branches',
      noCategories: 'No categories available for this branch',
      loading: 'Loading...',
    },
    
    // Branch Selector
    branchSelector: {
      title: 'Choose Your Branch',
      subtitle: 'Please select the branch you want to browse products from',
      searchPlaceholder: 'Search for a branch...',
      skip: 'Skip',
      noBranches: 'No branches available',
      // Branch names and locations
      branchNames: {
        1: 'Riyadh Branch',
        2: 'Jeddah Branch',
        3: 'Dammam Branch',
        4: 'Khobar Branch',
        5: 'Taif Branch',
        6: 'Abha Branch'
      },
      branchLocations: {
        1: 'Riyadh, Al-Nakheel District',
        2: 'Jeddah, Al-Zahra District',
        3: 'Dammam, Al-Faisaliyah District',
        4: 'Khobar, Corniche District',
        5: 'Taif, Al-Shuhada District',
        6: 'Abha, Airport District'
      }
    },
    
    // Search
    search: {
      title: 'Search',
      placeholder: 'Search for a product, category, or branch...',
      resultsFound: 'Found',
      result: 'result',
      results: 'results',
      products: 'Products',
      categories: 'Categories',
      branches: 'Branches',
      noResults: 'No results found',
      tryDifferent: 'Try searching with different words',
      enterSearch: 'Please enter a search term',
      category: 'Category',
      type: 'Type',
      loading: 'Searching...'
    },
    contact: {
      phone: 'Phone',
      whatsapp: 'WhatsApp',
      email: 'Email',
      address: 'Address',
      website: 'Website',
      noContactInfo: 'No contact information available right now.'
    },
    
    // Category names
    categoryNames: {
      baits: 'Baits',
      boxes: 'Group Boxes',
      choosendrinks: 'Selected Drinks',
      crepes: 'Crepes',
      drinkboxes: 'Drink Boxes',
      hotcoffees: 'Hot Coffee',
      matcha: 'Matcha',
      minicakes: 'Mini Cakes',
      mohito: 'Mojito',
      morning: 'Morning Treat',
      products: 'Our Products',
      smoothies: 'Smoothies',
      souchi: 'Sushi',
      waffel: 'Waffle'
    },
    
    // Product names and descriptions
    productNames: {
      // Baits
      'baits.1.name': 'Bait 1',
      'baits.1.description': 'Delicious and unique bait with a special flavor',
      'baits.2.name': 'Bait 2',
      'baits.2.description': 'Tasty bait with high quality',
      'baits.3.name': 'Bait 3',
      'baits.3.description': 'Special bait with great taste',
      
      // Boxes
      'boxes.1.name': 'Box 1',
      'boxes.1.description': 'Perfect group box for gatherings',
      'boxes.2.name': 'Box 2',
      'boxes.2.description': 'Special box with various choices',
      'boxes.3.name': 'Box 3',
      'boxes.3.description': 'Economical box with high quality',
      'boxes.4.name': 'Box 4',
      'boxes.4.description': 'Luxury box with special choices',
      'boxes.5.name': 'Box 5',
      'boxes.5.description': 'Large box with abundant quantity',
      'boxes.6.name': 'Box 6',
      'boxes.6.description': 'Medium sized box',
      
      // Choosendrinks
      'choosendrinks.1.name': 'Selected Drink 1',
      'choosendrinks.1.description': 'Refreshing and natural drink',
      'choosendrinks.2.name': 'Selected Drink 2',
      'choosendrinks.2.description': 'Special drink with unique flavor',
      'choosendrinks.3.name': 'Selected Drink 3',
      'choosendrinks.3.description': 'Refreshing and healthy drink',
      'choosendrinks.4.name': 'Selected Drink 4',
      'choosendrinks.4.description': 'Luxury drink with high quality',
      
      // Crepes
      'crepes.1.name': 'Crepe 1',
      'crepes.1.description': 'Delicious and sweet crepe',
      'crepes.2.name': 'Crepe 2',
      'crepes.2.description': 'Special crepe with multiple layers',
      
      // Drinkboxes
      'drinkboxes.1.name': 'Drink Box 1',
      'drinkboxes.1.description': 'Variety drink box',
      'drinkboxes.2.name': 'Drink Box 2',
      'drinkboxes.2.description': 'Luxury drink box',
      'drinkboxes.3.name': 'Drink Box 3',
      'drinkboxes.3.description': 'Economical drink box',
      'drinkboxes.4.name': 'Drink Box 4',
      'drinkboxes.4.description': 'Medium drink box',
      'drinkboxes.5.name': 'Drink Box 5',
      'drinkboxes.5.description': 'Large drink box',
      'drinkboxes.6.name': 'Drink Box 6',
      'drinkboxes.6.description': 'Variety drink box',
      
      // Hotcoffees
      'hotcoffees.1.name': 'Hot Coffee 1',
      'hotcoffees.1.description': 'Authentic Arabic coffee',
      'hotcoffees.2.name': 'Hot Coffee 2',
      'hotcoffees.2.description': 'Luxury Italian coffee',
      'hotcoffees.3.name': 'Hot Coffee 3',
      'hotcoffees.3.description': 'Traditional Turkish coffee',
      'hotcoffees.4.name': 'Hot Coffee 4',
      'hotcoffees.4.description': 'Strong American coffee',
      'hotcoffees.5.name': 'Hot Coffee 5',
      'hotcoffees.5.description': 'Italian espresso',
      'hotcoffees.6.name': 'Hot Coffee 6',
      'hotcoffees.6.description': 'Creamy latte',
      
      // Matcha
      'matcha.1.name': 'Matcha 1',
      'matcha.1.description': 'Authentic Japanese matcha',
      'matcha.2.name': 'Matcha 2',
      'matcha.2.description': 'Luxury matcha with high quality',
      'matcha.3.name': 'Matcha 3',
      'matcha.3.description': 'Refreshing and natural matcha',
      
      // Minicakes
      'minicakes.1.name': 'Mini Cake 1',
      'minicakes.1.description': 'Delicious mini cake',
      'minicakes.2.name': 'Mini Cake 2',
      'minicakes.2.description': 'Mini cake with multiple layers',
      'minicakes.3.name': 'Mini Cake 3',
      'minicakes.3.description': 'Simple mini cake',
      'minicakes.4.name': 'Mini Cake 4',
      'minicakes.4.description': 'Special mini cake',
      'minicakes.5.name': 'Mini Cake 5',
      'minicakes.5.description': 'Luxury mini cake',
      'minicakes.6.name': 'Mini Cake 6',
      'minicakes.6.description': 'Refreshing mini cake',
      
      // Mohito
      'mohito.1.name': 'Mojito 1',
      'mohito.1.description': 'Refreshing and natural mojito',
      'mohito.2.name': 'Mojito 2',
      'mohito.2.description': 'Luxury mojito with special flavor',
      'mohito.3.name': 'Mojito 3',
      'mohito.3.description': 'Classic mojito',
      'mohito.4.name': 'Mojito 4',
      'mohito.4.description': 'Special mojito with unique taste',
      'mohito.5.name': 'Mojito 5',
      'mohito.5.description': 'Luxury mojito with high quality',
      'mohito.6.name': 'Mojito 6',
      'mohito.6.description': 'Refreshing and healthy mojito',
      
      // Morning
      'morning.1.name': 'Morning Treat 1',
      'morning.1.description': 'Delicious morning treat',
      'morning.2.name': 'Morning Treat 2',
      'morning.2.description': 'Luxury morning treat',
      'morning.3.name': 'Morning Treat 3',
      'morning.3.description': 'Simple morning treat',
      
      // Products
      'products.1.name': 'Product 1',
      'products.1.description': 'Special product with high quality',
      'products.2.name': 'Product 2',
      'products.2.description': 'Luxury product with great taste',
      'products.3.name': 'Product 3',
      'products.3.description': 'Economical product',
      'products.4.name': 'Product 4',
      'products.4.description': 'Medium quality product',
      
      // Smoothies
      'smoothies.1.name': 'Smoothie 1',
      'smoothies.1.description': 'Natural and healthy smoothie',
      
      // Souchi
      'souchi.1.name': 'Sushi 1',
      'souchi.1.description': 'Authentic Japanese sushi',
      'souchi.2.name': 'Sushi 2',
      'souchi.2.description': 'Luxury sushi with high quality',
      'souchi.3.name': 'Sushi 3',
      'souchi.3.description': 'Traditional sushi',
      
      // Waffel
      'waffel.1.name': 'Waffle 1',
      'waffel.1.description': 'Delicious and crispy waffle',
      'waffel.2.name': 'Waffle 2',
      'waffel.2.description': 'Luxury waffle with multiple layers',
      'waffel.3.name': 'Waffle 3',
      'waffel.3.description': 'Simple waffle',
      'waffel.4.name': 'Waffle 4',
      'waffel.4.description': 'Special waffle',
      'waffel.5.name': 'Waffle 5',
      'waffel.5.description': 'Luxury waffle',
      'waffel.6.name': 'Waffle 6',
      'waffel.6.description': 'Refreshing waffle'
    },
    
    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      logout: 'Logout',
      overview: 'Overview',
      totalViews: 'Total Views',
      todayViews: 'Today\'s Views',
      weekViews: 'This Week',
      monthViews: 'This Month',
      categories: 'Categories',
      products: 'Products',
      branches: 'Branches',
      heroImages: 'Hero Images',
      analytics: 'Analytics',
      viewsByDevice: 'Views by Device',
      dailyViews: 'Daily Views',
      topPages: 'Top Pages',
      mobile: 'Mobile',
      desktop: 'Desktop',
      tablet: 'Tablet',
      views: 'Views',
      page: 'Page',
      noData: 'No data available',
      manageCategories: 'Manage Categories',
      manageProducts: 'Manage Products',
      manageBranches: 'Manage Branches',
      viewAll: 'View All',
      period: 'Period',
      last7Days: 'Last 7 Days',
      last30Days: 'Last 30 Days',
      last90Days: 'Last 90 Days',
      allergensAdditions: 'Allergens & Additions',
      loading: 'Loading...'
    },
    
    // Admin Pages
    admin: {
      back: 'Back',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      save: 'Save',
      cancel: 'Cancel',
      loading: 'Loading...',
      categories: 'Categories',
      products: 'Products',
      branches: 'Branches',
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      addProduct: 'Add Product',
      editProduct: 'Edit Product',
      addBranch: 'Add Branch',
      editBranch: 'Edit Branch',
      deleteConfirm: 'Are you sure you want to delete this item?',
      keyName: 'Key Name',
      nameAr: 'Name (Arabic)',
      nameEn: 'Name (English)',
      descriptionAr: 'Description (Arabic)',
      descriptionEn: 'Description (English)',
      image: 'Image',
      displayOrder: 'Display Order',
      active: 'Active',
      category: 'Category',
      selectCategory: 'Select Category',
      price: 'Price',
      priceSAR: 'Price (SAR)',
      calories: 'Calories',
      caloriesPlaceholder: 'Enter calories',
      ingredients: 'Ingredients',
      ingredientAr: 'Ingredient (Arabic)',
      ingredientEn: 'Ingredient (English)',
      addIngredient: 'Add Ingredient',
      remove: 'Remove',
      logo: 'Logo',
      logoHint: 'Upload the site logo (recommended PNG/WebP with transparent BG).',
      saveLogo: 'Save Logo',
      currentLogo: 'Current logo',
      logoUpdated: 'Logo updated successfully',
      noLogo: 'No logo set',
      preview: 'Preview',
      saving: 'Saving...',
      search: 'Search',
      searchPlaceholder: 'Search by name',
      allCategories: 'All categories',
      status: 'Status',
      all: 'All',
      inactive: 'Inactive',
      results: 'Results',
      noResults: 'No products match your filters',
      locationAr: 'Location (Arabic)',
      locationEn: 'Location (English)',
      phone: 'Phone',
      branchCategories: 'Branch Categories',
      id: 'ID',
      key: 'Key',
      order: 'Order',
      actions: 'Actions',
      yes: 'Yes',
      no: 'No',
      required: 'Required',
      error: 'An error occurred',
      manageSizes: 'Manage Sizes',
      sizesList: 'Sizes List',
      sizeNameAr: 'Size Name (Arabic)',
      sizeNameEn: 'Size Name (English)',
      noSizes: 'No sizes added yet',
      clear: 'Clear',
      update: 'Update',
      close: 'Close',
      heroImages: 'Hero Images',
      heroImage: 'Hero Image',
      addHeroImage: 'Add Hero Image',
      editHeroImage: 'Edit Hero Image',
      titleAr: 'Title (Arabic)',
      titleEn: 'Title (English)',
      link: 'Link',
      linkUrl: 'Link URL',
      linkUrlHint: 'If provided, clicking the image will navigate to this URL',
      displayOrderHint: 'Lower numbers appear first in the slider',
      activeHint: 'Only active images will be shown on the website',
      noHeroImages: 'No hero images found. Add your first image!',
      allergensAdditions: 'Allergens & Additions',
      manageAllergens: 'Manage Allergens',
      manageFixedAdditions: 'Manage Fixed Additions',
      allergen: 'Allergen',
      addition: 'Addition',
      icon: 'Icon',
      errorLoadingData: 'Error loading data',
      errorSavingAllergen: 'Error saving allergen',
      errorSavingAddition: 'Error saving addition',
      deleteAllergenConfirm: 'Are you sure you want to delete this allergen?',
      deleteAdditionConfirm: 'Are you sure you want to delete this addition?',
      errorLoadingProductDetails: 'Failed to load product details',
      productAllergensLabel: 'Allergens (choose what this product contains)',
      allowedAdditionsLabel: 'Allowed Additions',
      discountPercent: 'Discount %',
      isBestseller: 'Best seller'
      ,
      contactSettings: 'Contact Settings',
      savedContact: 'Contact details saved'
    }
  }
};

// Helper function to get translation
export const getTranslation = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    value = value?.[k];
  }
  
  return value || key;
};

